import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    coupon: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    var response = await API.coupon.create (payload);
    //update list after screener is crated
    await context.dispatch ('list');
    return response;
  },

  async get (context, payload) {
    var coupon = context.getters['getCoupon'] (payload.id);
    /* if not in state get from api */
    if (coupon == undefined) {
      var response = await API.coupon.get (payload);
      coupon = response.coupon;
    }
    return coupon;
  },

  async delete (context, payload) {
    var response = await API.coupon.delete (payload);
    return response;
  },

  async list (context, payload) {
    var response = await API.coupon.list (payload);
    // set coupons in list
    context.commit ('set_list', {
      coupons: response.coupons,
    });
    return response;
  },

  async update (context, payload) {
    var response = await API.coupon.update (payload);
    await context.dispatch ('list');
    return response;
  },

  async export (context, payload) {
    var response = await API.coupon.export (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getCoupon: state => id => {
    var coupon = null;
    if (state.list.data) {
      coupon = state.list.data.find (coupon => {
        return coupon.id == id;
      });
    }
    return coupon;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.coupons.data;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
